import { Typography } from "@lyfegen-platform/react-common";
import { Box, Theme } from "@material-ui/core";
import FlexTypographyComponent from "../../FlexTypographyComponent";
import { invoiceStatusToColor, getInvoiceStatusIcon } from "../utils/status";

interface InvoiceStatusProps {
	props: any;
	children: React.ReactNode;
	palette: Theme["palette"];
	t: any;
}

const Text: React.FC<InvoiceStatusProps> = ({ props, palette, t }) => (
	<Typography
		type="status"
		style={{
			marginLeft: "2px",
			color: (props.status && invoiceStatusToColor(props.status, palette, true)) || "black",
		}}
	>
		<FlexTypographyComponent type="status" text={props.text} />
	</Typography>
);

const InvoiceStatus: React.FC<InvoiceStatusProps> = ({ props, children, palette, t }) => {
	return (
		<Box
			display="flex"
			alignItems="center"
			style={{
				height: "22px",
				borderRadius: "100px",
				backgroundColor: invoiceStatusToColor(props?.status, palette),
				padding: "3px 8px 3px 6px",
				fontWeight: 600,
				maxWidth: "fit-content",
				...props?.style,
			}}
		>
			<div style={{ lineHeight: "12px" }}>{getInvoiceStatusIcon(props.status)}</div>
			<Text props={props} palette={palette} t={t} children={children} />
		</Box>
	);
};

export default InvoiceStatus;
